export default __webpack_public_path__ + "static/media/Sortlist.7b4b7b28.webp";